export const APP_MASTER_DETAIL = {
  "Masterdetail.Space.Around": {
    defaultValue: "default"
  },
  "Masterdetail.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Masterdetail.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Masterdetail.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Masterdetail.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Masterdetail.Height.Type": {
    defaultValue: "fixed"
  },

  "Masterdetail.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Masterdetail.Shadow.Type": {
    defaultValue: "none"
  },
  "Masterdetail.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Masterdetail.Width": {
    defaultValue: "100%"
  },
  "Masterdetail.Height": {
    defaultValue: "500px"
  },
  "Masterdetail.Min.Height": {
    defaultValue: "0px"
  },
  "Masterdetail.Min.Width": {
    defaultValue: "unset"
  },
  "Masterdetail.Max.Height": {
    defaultValue: "unset"
  },
  "Masterdetail.Max.Width": {
    defaultValue: "unset"
  },
  "Masterdetail.Margin.Top": {
    defaultValue: "0px"
  },
  "Masterdetail.Margin.Left": {
    defaultValue: "0px"
  },
  "Masterdetail.Margin.Right": {
    defaultValue: "0px"
  },
  "Masterdetail.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Masterdetail.Header.Caption.Color": {
    ref: "Color.Gray.800"
  },
  "Masterdetail.Header.Caption.Font.Size": {
    ref: "Font.Size.16"
  },
  "Masterdetail.Header.Caption.Value.Color": {
    ref: "Color.Gray.400"
  },
  "Masterdetail.Header.Caption.Value.Font.Size": {
    ref: "Font.Size.14"
  },
  "Masterdetail.Padding.Left": {
    defaultValue: "0px"
  },
  "Masterdetail.Padding.Right": {
    defaultValue: "0px"
  },
  "Masterdetail.Padding.Top": {
    defaultValue: "0px"
  },
  "Masterdetail.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Masterdetail.Border.Color": {
    ref: "Color.Transparent"
  },
  "Masterdetail.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.List.Gap": {
    defaultValue: "0px"
  },
  "Masterdetail.List.Bg.Color": {
    ref: "Color.White"
  },
  "Masterdetail.List.Separator.Color": {
    ref: "Color.Gray.300"
  },
  "Masterdetail.List.Separator.Width": {
    defaultValue: "1px"
  },
  "Masterdetail.Card.Icon.Size": {
    defaultValue: "32px"
  },
  "Masterdetail.Card.Icon.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Masterdetail.Card.Icon.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Border.Style": {
    defaultValue: "solid"
  },
  "Masterdetail.Card.Icon.Border.Color": {
    ref: "Color.Transparent"
  },
  "Masterdetail.Card.Icon.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Padding.Left": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Padding.Right": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Padding.Top": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Icon.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Masterdetail.Card.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Masterdetail.Card.Title.Color": {
    ref: "Color.Gray.800"
  },
  "Masterdetail.Card.Title.Font.Size": {
    ref: "Font.Size.14"
  },
  "Masterdetail.Card.Title.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Masterdetail.Card.Title.Line.Height": {
    ref: "Line.Height.Base"
  },
  "Masterdetail.Card.Title.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Masterdetail.Card.Sub.Title.Color": {
    ref: "Color.Gray.600"
  },
  "Masterdetail.Card.Sub.Title.Font.Size": {
    ref: "Font.Size.12"
  },
  "Masterdetail.Card.Sub.Title.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Masterdetail.Card.Sub.Title.Line.Height": {
    ref: "Line.Height.Base"
  },
  "Masterdetail.Card.Sub.Title.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Masterdetail.Card.Separator.Color": {
    ref: "Color.Gray.200"
  },
  "Masterdetail.Card.Separator.Width": {
    defaultValue: "1px"
  },
  "Masterdetail.Card.Icon.Color": {
    ref: "Color.Gray.500"
  },
  "Masterdetail.Card.Arrow.Size": {
    defaultValue: "20px"
  },
  "Masterdetail.Card.Arrow.Color": {
    ref: "Color.Gray.500"
  },
  "Masterdetail.Card.Padding.Left": {
    ref: "Space.16"
  },
  "Masterdetail.Card.Padding.Right": {
    ref: "Space.16"
  },
  "Masterdetail.Card.Padding.Top": {
    ref: "Space.8"
  },
  "Masterdetail.Card.Padding.Bottom": {
    ref: "Space.8"
  },
  "Masterdetail.Card.Shadow": {
    defaultValue: "none"
  },
  "Masterdetail.Card.Hover.Bg.Color": {
    ref: "Color.Primary.100"
  },
  "Masterdetail.Card.Selected.Bg.Color": {
    ref: "Color.Primary.200"
  },
  "Masterdetail.Card.Selected.Icon.Color": {
    ref: "Color.Gray.500"
  },
  "Masterdetail.Container.Flex.Direction": {
    defaultValue: "row"
  },
  "Masterdetail.Container.Flex.Wrap": {
    defaultValue: "wrap"
  },
  "Masterdetail.Container.Card.Gap": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Column.Gap": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Row.Gap": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Width": {
    defaultValue: "100%"
  },
  "Masterdetail.Container.Min.Width": {
    defaultValue: "unset"
  },
  "Masterdetail.Container.Margin.Top": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Margin.Right": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Margin.Left": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Padding.Top": {
    defaultValue: "10px"
  },
  "Masterdetail.Container.Padding.Right": {
    defaultValue: "10px"
  },
  "Masterdetail.Container.Padding.Bottom": {
    defaultValue: "10px"
  },
  "Masterdetail.Container.Padding.Left": {
    defaultValue: "10px"
  },
  "Masterdetail.Container.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Border.Color": {
    ref: "Color.Black"
  },
  "Masterdetail.Container.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Masterdetail.Container.Height": {
    defaultValue: "100%"
  },
  "Masterdetail.Container.Overflow": {
    defaultValue: "auto"
  },
  "Masterdetail.Container.Align.Items": {
    defaultValue: "flex-start"
  },
  "Masterdetail.Container.Justify.Content": {
    defaultValue: "flex-start"
  },
  "Masterdetail.Container.Align.Content": {
    defaultValue: "flex-start"
  },
  "Masterdetail.Container.Display": {
    defaultValue: "flex"
  },
  "Masterdetail.Container.Min.Height": {
    defaultValue: "unset"
  },
  "Masterdetail.Container.Box.Sizing": {
    defaultValue: "border-box"
  },
  "Masterdetail.Container.Background": {
    ref: "Color.Transparent"
  },
  "Masterdetail.Container.Background.Color": {
    ref: "Color.Transparent"
  },
  "Masterdetail.Container.Border.Style": {
    defaultValue: "solid"
  },
  "Masterdetail.Container.Max.Height": {
    defaultValue: "unset"
  },
  "Masterdetail.Container.Max.Width": {
    defaultValue: "unset"
  },
  "Masterdetail.Container.Box.Shadow": {
    defaultValue: "none"
  },
  "Masterdetail.Highlight.Color": {
    ref: "Color.Primary.100"
  },
  "Masterdetail.Active.Color": {
    ref: "Color.Primary.200"
  },
  "Masterdetail.Icon.Color": {
    ref: "Color.Gray.600"
  },
  "Masterdetail.Cursor": {
    defaultValue: "pointer"
  },
  "Masterdetail.Box.Sizing": {
    defaultValue: "border-box"
  }
};
